// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-table__body[data-v-0f071035] {\r\n  width: 100%;\r\n  table-layout: fixed !important;\n}\n.text_overflow[data-v-0f071035] {\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  max-width: 400px;\n}\n.pup_card[data-v-0f071035] {\r\n  width: 200px;\r\n  border-radius: 5px;\r\n  padding: 5px;\r\n  -webkit-box-sizing: border-box;\r\n          box-sizing: border-box;\r\n  font-size: 12px;\r\n  line-height: 16px;\n}\r\n", ""]);
// Exports
module.exports = exports;
